import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Heading } from "./ui/heading";
import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
// import { useCookie } from "react-use";
import * as reactUse from "react-use";


const { useCookie } = reactUse;

export default function () {
  const [cookie, updateCookie, deleteCookie] = useCookie(
    "cookies-policy-accepted"
  );

  const handleClick = () => {
    updateCookie(true, { expires: 365 });
  };

  return (
    <Dialog open={!cookie} modal={false}>
      {/* <DialogTrigger>Open</DialogTrigger> */}
      <DialogContent
        showCloseButton={false}
        className="inset-x-2 xl:left-12  !bottom-2 xl:bottom-12 translate-x-0 translate-y-0 p-8 max-w-none gap-2 w-auto top-auto"
      >
        <Heading size="h3">Мы используем файлы cookie</Heading>
        <div className="space-y-4">
          <p>
            Мы обрабатываем файлы cookie, чтобы улучшить работу сайта. Оставаясь
            на нашем сайте, вы соглашаетесь с{" "}
            <Link className="underline" href="/privacy-policy">
              Политикой пользовательских данных
            </Link>
            .
          </p>
          <p>
            Если вы хотите запретить обработку файлов cookie, отключите cookie в
            настройках вашего браузера{" "}
            <Link href="/cookies-policy" className="underline">
              Подробнее
            </Link>
          </p>
        </div>

        <div className="pt-4">
          <Button className="" size="lg" onClick={handleClick}>
            Хорошо, закрыть
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
